import { LOGIN, SELECT_BRANCH, GET_USER_BRANCHES, SET_FEE, RESET_APP } from '../constants'

const initialState = {
    userData: [],
    profile: {
        firstName: '',
        lastName: '',
        telephone: '',
        age: 28,
        email: '',
        state: '',
        country: '',
        address: 'Home',
        address1: '',
        address2: '',
        interests: [],
        profileImage: '',
        subscribenewsletter: false,
        token: '',
        userID: ''
    },
    token: '',
    selectedBranchId: '',
    selectedBranchNumber: '',
    selectedBranchName: '',
    isBranchSelected: false,
    branch: {
        title: '',
        number: '',
        id: ''
    },
    userBranches: [],
    isLoggedIn: false,
    userID: '',
    TotalFee: 0,
    IncrementalFee: 0,
}

export default function userItems(state = initialState, action) {
    // console.log('reducer', state, action);
    switch (action.type) {
        case RESET_APP:
            return "App is reset"
            break;

        case SELECT_BRANCH:
            return {
                ...state,
                selectedBranchId: action.data.id,
                selectedBranchNumber: action.data.Number,
                selectedBranchName: action.data.Name,
                isBranchSelected: true
            }
            break;

        case SET_FEE:
            return {
                ...state,
                TotalFee: action.data.TotalFee,
                IncrementalFee: action.data.IncrementalFee,
            }
            break;
        case LOGIN:
            return {
                ...state,
                token: action.data.token,
                userID: action.data.userID
            }
            break;

        case GET_USER_BRANCHES:
            return {
                ...state,
                userBranches: action.data
            };

            break;
        default:
            return state
    }
}